import { observer } from 'mobx-react-lite'
import React from 'react'
import TagsPage from './TagsPage'
import ProfilePage from './ProfilePage'
import PMThread from './PMThread'
import ClientThread from './ClientThread'
import CampaignInfluencerSidebarPageRoutes from '../../../../../Shared/CampaignInfluencerSidebar/CampaignInfluencerSidebarPageRoutes'

export default observer(function CampaignInfluencerSidebarPage({ auth }){

  return (
    <CampaignInfluencerSidebarPageRoutes
      auth={auth}
      TagsComponent={TagsPage}
      ProfileComponent={ProfilePage}
      PMThreadComponent={PMThread}
      ClientThreadComponent={ClientThread}
      showTags
      showPmThread
    />
  )
})
